export default __webpack_public_path__ + "static/media/ai-image-generator-screenshot-03.ca7b0c60.png";